import styled from 'styled-components'

export const Divider = styled.div`
  height: 1rem;
  border-left: 0.063rem solid var(--gray-200);
`

Divider.displayName = 'Divider'

export const CustomButton = styled.button`
  &:focus,
  :active {
    outline: 0;
  }
`

CustomButton.displayName = 'CustomButtonPostModalHeader'
